import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Button      from '@material-ui/core/Button/Button'
import Card        from '@material-ui/core/Card/Card'
import CardActions from '@material-ui/core/CardActions/CardActions'
import CardHeader  from '@material-ui/core/CardHeader/CardHeader'

import { Study } from '../../api'

interface StudyCardProps {
  onRemove: () => void
  study: Study
}

const StudyCard: React.SFC<StudyCardProps> = ({
  onRemove,
  study:
    {
      name,
      school,
    },
}) => {
  return (
    <Card>
      <CardHeader
        title={name}
        subheader={school}
      />
      <CardActions>
        <Button
          onClick={onRemove}
          variant={'raised'}
          color={'secondary'}
        >
          <FormattedMessage id={'buttonActions.remove'} />
        </Button>
      </CardActions>
    </Card>
  )
}

export default StudyCard



// WEBPACK FOOTER //
// ./src/components/molecules/StudyCard.tsx